import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CNDrug } from '../models/cndrug';
import { CNDrugPackage } from '../models/cndrugpackage';
import { SNItem } from '../models/snitem';
import { SNItemFactory } from '../models/snitemfactory';
import { SNItemTableControl, SNItemTableService, SNItemTableServiceCapability } from '../snitem-table/snitem-table-interface';
import { BecareService } from './becare.service';

@Injectable({
  providedIn: 'root'
})
export class DrugService {

  private static instance: DrugService = null;

  searching = false;

  constructor(private becare: BecareService, private factory: SNItemFactory) { }

  public static getInstance(): DrugService {
    return DrugService.instance;
  }

  search(value: string): Observable<CNDrug[]> {
    return new Observable(observer => {
      this.searching = true;
      this.becare.call('/drug/search', [['v', value]]).subscribe(result => {
        if (result.success === true && result.drugs !== undefined) {
          // Instanciates all doctor items
          const drugs: CNDrug[] = this.factory.itemsFromJson(result.drugs);
          observer.next(drugs);
        } else {
          observer.error('error while searching for drug');
        }
      }, error => {
        this.searching = false;
        observer.error(error);
      });
    });
  }

  packages(drug: CNDrug): Observable<CNDrugPackage[]> {
    return new Observable(observer => {
      this.searching = true;
      this.becare.call('/drug/' + drug.id + '/packages').subscribe(result => {
        if (result.success === true && result.packages !== undefined) {
          // Instanciates all doctor items
          const packages: CNDrugPackage[] = [];
          result.packages.forEach(apackage => {
            const packageItem: CNDrugPackage = this.factory.itemFromJson(apackage);
            packageItem.addParent(drug, false); // Link to parent
            if (apackage.childs) {
              apackage.childs.forEach(achild => {
                const achildItem: SNItem = this.factory.itemFromJson(achild);
                packageItem.addChild(achildItem, false); // Add to cache
              });
            }
            packages.push(packageItem);
          });
          observer.next(packages);
        } else {
          observer.error('error while searching for drug');
        }
      }, error => {
        this.searching = false;
        observer.error(error);
      });
    });
  }
}
